import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';
import { MobileNavService } from '../../shared/services/mobile-nav.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    constructor( public authService: AuthService, private mobileNav: MobileNavService) { }

    ngOnInit() {
        let cheeta;
        cheeta = '50';

        // console.log(cheeta);
        // this.authService.getUsers().then(
        //   res => { // Success
        //       console.log(res);
        //   },
        //   err => {
        //       // this.error = 'Username or password is incorrect';
        //       console.log(err);
        //   }
        // );
    }

    onClickMe() {
        this.mobileNav.showSideNav();
        console.log('Home component ');
    }

}
